import * as React from "react"
import {Box} from "@mui/material";
import {ButtonSeeker, IconSeeker, ImageSeeker} from "@ui-seeker/core";


export default function MatchersFinishPage({onClick}) {
    return <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
        <ButtonSeeker
            color="info"
            startIcon={<IconSeeker icon="cart-plus" />}
            onClick={onClick}
            sx={{mb: 2}}
        >
            Need more SKUs
        </ButtonSeeker><ImageSeeker
            src="/images/finish2.gif"
            sx={{ width: '60vw', height: "60vh" }}
        />
    </Box>
}